import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { init, pageView, track, flush } from "./sdk";

const MARKS = [25, 50, 75, 90];
const state = { first: true };

export const useAnalytics = () => {
  const { pathname } = useLocation();
  const ready = useRef(false);
  const seen = useRef(new Set());
  const lastActive = useRef(Date.now());
  const acc = useRef(0);
  const tick = useRef(Date.now());

  useEffect(() => { ready.current = init(); }, []);

  useEffect(() => {
    if (!ready.current || pathname.startsWith("/admin")) return;
    seen.current = new Set();
    acc.current = 0;
    tick.current = Date.now();
    const t = setTimeout(pageView, state.first ? 400 : 50);
    state.first = false;
    return () => clearTimeout(t);
  }, [pathname]);

  useEffect(() => {
    if (!ready.current) return;
    const activity = () => { lastActive.current = Date.now(); };
    const onScroll = () => {
      activity();
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const depth = h > 0 ? Math.round(((window.scrollY + 0) / h) * 100) : 100;
      MARKS.forEach((m) => { if (depth >= m && !seen.current.has(m)) { seen.current.add(m); track("scroll_depth", { depth: m }); } });
    };
    const onClick = (e) => {
      activity();
      const el = e.target.closest("[data-track]");
      if (el) track("click", { name: el.getAttribute("data-track"), label: el.getAttribute("data-track-label") || undefined });
    };
    const beat = () => {
      const now = Date.now();
      if (document.visibilityState === "visible" && now - lastActive.current < 30000) acc.current += now - tick.current;
      tick.current = now;
      if (acc.current > 0) { track("heartbeat", { active_ms: acc.current }); acc.current = 0; }
    };
    const onHide = () => { beat(); flush(true); };
    ["mousemove", "keydown", "touchstart", "pointerdown"].forEach((ev) => window.addEventListener(ev, activity, { passive: true }));
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("click", onClick, true);
    const iv = setInterval(beat, 10000);
    window.addEventListener("pagehide", onHide);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") onHide(); });
    return () => {
      ["mousemove", "keydown", "touchstart", "pointerdown"].forEach((ev) => window.removeEventListener(ev, activity));
      window.removeEventListener("scroll", onScroll); document.removeEventListener("click", onClick, true);
      clearInterval(iv); window.removeEventListener("pagehide", onHide);
    };
  }, []);
};
